import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstPr3: [],
		pr3: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, pr3){
			state.pr3 = pr3
			if (pr3)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.pr3 = null
		},
		setParamsDataTable(state, payload){
			state.lstPr3 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, { pr3produto, pr3tamanho}){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Products/ProductSize/Find/${pr3produto}/${pr3tamanho}`)
			.then(response => {
				let pr3 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", pr3)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.pr3.pr3codigo){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Products/ProductSize/Insert", store.state.pr3 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tamanhos-de-produtos")
				store.state.pr3 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Products/ProductSize/Update", store.state.pr3 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tamanhos-de-produtos")
				store.state.pr3 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async verifyChildrenAndDeletePermission({ dispatch },{ pr3produto, pr3tamanho, silent = false }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            let response = await this._vm.$axios.get(`/Products/ProductSize/VerifyChildrenAndDeletePermission/`, { params:  { pr3produto, pr3tamanho } })
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                })
                .catch((error) => {
					if(!silent){
						dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						}, { root: true })
					}
                    return true
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return response
        },
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Products/ProductSize/Delete/${store.state.pr3.pr3codigo}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tamanhos-de-produtos")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store, pr3produto){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get("/Products/ProductSize/FindList/"+pr3produto)
			.then(response => {
				let lstPr3 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstPr3 = lstPr3
				return true
			}).catch(error => {
				store.state.lstPr3 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
			return payload
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Products/ProductSize/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstPr3 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async saveAll({ dispatch }, { pr3produto, lstPr3 }){
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando grade de tamanho", indeterminate: true },
				{ root: true },
			)
			lstPr3 = lstPr3.map(pr3 => {
				pr3.pr3produto = pr3produto
				pr3.pr3lotemul = parseFloat(pr3.pr3lotemul)
				pr3.pr3pesoliq = Number(pr3.pr3pesoliq.toString().replace(',', '.')) || 0
				return pr3
			})
			let payload = await this._vm.$axios.post("/Products/ProductSize/SaveAll/", lstPr3, { params: { pr3produto: pr3produto } })
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findPr3posicaoByPr3tamanho({ dispatch }, { lstPr3tamanho, pr3produto } ){
			let payload = await this._vm.$axios.post("/Products/ProductSize/FindPr3posicaoByPr3tamanho/", lstPr3tamanho, { params: { pr3produto: pr3produto } })
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			return payload
		},
	}
}